import { SWRConfiguration } from 'swr';

import { UseSWROutput, useSWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';

export enum AppraisalTemplateComponentType {
  TEXT = 'TEXT',
  EVALUATIONS = 'EVALUATIONS',
  MULTIPLE_CHOICE = 'CHECKBOXES',

  // SUBTITLE = 'SUBTITLE',
  // LINK = 'LINK',
  // DATE = 'DATE',
  // SCALE = 'SCALE',
  // COMPETENCY_LEVEL = 'COMPETENCY_LEVEL',
  // FILE = 'FILE',
  // DROPDOWN = 'DROPDOWN',
  // MULTISELECT_DROPDOWN = 'MULTISELECT_DROPDOWN',
  // SCORE = 'SCORE',
}

type AppraisalTemplateComponent_Common = {
  id: string;
  language: string;
  name: string;
  index: number;
};

export type AppraisalTemplateComponent_TEXT = {
  type: AppraisalTemplateComponentType.TEXT;
} & AppraisalTemplateComponent_Common;

export type AppraisalTemplateComponent_MULTIPLE_CHOICE = {
  type: AppraisalTemplateComponentType.MULTIPLE_CHOICE;
  options: {
    id: number;
    label: string;
    index: number;
  }[];
} & AppraisalTemplateComponent_Common;

export type AppraisalTemplateComponent_EVALUATIONS = {
  type: AppraisalTemplateComponentType.EVALUATIONS;
  options: {
    id: number;
    label: string;
    index: number;
  }[];
} & AppraisalTemplateComponent_Common;

// TODO Include with other component types
export type AppraisalTemplateComponent =
  | AppraisalTemplateComponent_TEXT
  | AppraisalTemplateComponent_MULTIPLE_CHOICE
  | AppraisalTemplateComponent_EVALUATIONS;

export type AppraisalTemplateSection = {
  id: string;
  language: string;
  name: string;
  templateId: string;
  empAccess: boolean;
  onlyEmpAccess: boolean;
  index: number;
  components: AppraisalTemplateComponent[];
};

export type AppraisalTemplate = {
  id: string;
  subject: string;
  isTeam: boolean;
  stages: [];
  status: string; // Enum
  deadline: string; // Date
  language: string;
  defaultLang: string;
  sections: AppraisalTemplateSection[];
  updatedBy: {
    id: number;
    username: string;
    employeeId: number;
  };
  updatedTime: string;
  createdTime: string;
  audience: {
    unitAudience: [];
    roleAudience: [];
    countryAudience: [];
  };
  tags: [];
};

export const getEmployeeAppraisalTemplates = async (
  employeeId: number,
): Promise<AppraisalTemplate[]> =>
  fetchFromOldApi(`/json/appraisal/templates/full/${employeeId}`)
    .then((r) => r.json())
    .then(({ data }) => data);

type UseGetEmployeeAppraisalTemplatesOutput = Omit<
  UseSWROutput<AppraisalTemplate[]>,
  'data'
> & {
  appraisalTemplates: AppraisalTemplate[];
};

export const useGetEmployeeAppraisalTemplates = (
  args: {
    employeeId?: number;
  },
  swrConfig?: SWRConfiguration<AppraisalTemplate[]>,
): UseGetEmployeeAppraisalTemplatesOutput => {
  const { employeeId } = args;

  const { data, ...rest } = useSWR(
    !!employeeId ? ['getEmployeeAppraisalTemplates', employeeId] : null,
    ([_key, employeeId]: [string, number]) =>
      getEmployeeAppraisalTemplates(employeeId),
    swrConfig,
  );

  return {
    appraisalTemplates: data ?? [],
    ...rest,
  };
};
